
import FirestoreModel from "../FirestoreModel"

export class Company extends FirestoreModel<Company>() {

  static collectionPath = () => ["companies"];
  static refPath = (companyId: string) => [...this.collectionPath(), companyId];
  static collection() {
    return this.pathToCollection(this.collectionPath());
  }
  static ref(companyId: string) {
    return super.pathToRef(this.refPath(companyId));
  }

  subscriptionId: string;
  name: string;
  stripePricingTableId: string;
  stripePublishableKey: string;
  currency: string;
  defaultLocation: string;
  supportEmail: string;

  constructor(snapshot: any) {
    super(snapshot);
    const data = snapshot.data();
    this.subscriptionId = data.subscriptionId;
    this.name = data.name;
    this.stripePricingTableId = data.stripePricingTableId;
    this.stripePublishableKey = data.stripePublishableKey;
    this.currency = data.currency;
    this.defaultLocation = data.defaultLocation;
    this.supportEmail = data.supportEmail;
  }
}
